import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerLoadMoreCard from '../../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../../MediaPickersConstants';

const BackgroundStockVideosLoadMoreCard = (props) => {
    const { 
        galleryCardWidth, galleryCardHeight, backgroundStockVideosPageNumber, searchBackgroundStockVideos,  backgroundStockVideosSearchValue, backgroundStockVideosLoading, setProperty, backgroundStockVideosOrientation
    } = props;
    
    const onLoadMoreButtonClick = () => {
        setProperty('backgroundStockVideosLoading', true);

        searchBackgroundStockVideos(backgroundStockVideosSearchValue, backgroundStockVideosOrientation, backgroundStockVideosPageNumber + 1, MediaPickersConstants.BACKGROUND_STOCK_VIDEOS_PER_PAGE, () => {
            setProperty('backgroundStockVideosLoading', false);
        });
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={backgroundStockVideosLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundStockVideosSearchValue, 
        backgroundStockVideosLoading,
        backgroundStockVideosOrientation,
        backgroundStockVideosPageNumber
    } = state.mediaPicker;

    return {
        backgroundStockVideosSearchValue,
        backgroundStockVideosOrientation, 
        backgroundStockVideosLoading,
        backgroundStockVideosPageNumber
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchBackgroundStockVideos = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchBackgroundStockVideos(keywords, orientation, pageNumber, itemsPerPage, callback));
   
    return { 
        setProperty,
        searchBackgroundStockVideos
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundStockVideosLoadMoreCard);